import React from "react";
import { SearchItem } from "../SearchItem/SearchItem";
import classes from "./SearchList.scss";

export const SearchList = props => {
  const { data = [], onSelectItem, searchText } = props;

  return (
    <div className={classes.container} role="list">
      {data.map(item => {
        const { id } = item;
        return (
          <SearchItem
            key={id}
            item={item}
            onSelectItem={onSelectItem}
            searchText={searchText}
          />
        );
      })}
    </div>
  );
};
